import React, { useEffect } from "react";
import { Table } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getFarmList, doFarmDelete } from "../../../../../redux/farm/farmState";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import { handleTableChange, displayAddress } from "../../../../../utils/index";

const FarmTable = ({ recordList, pagination, doSearch, doDelete, filters, accountId }) => {
	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
	    {
	        title: `Farm Name`,
	        dataIndex: 'name',
	        key: 'name',
	        width: '40%',
	        sorter: true,
	        ...getColumnSearchProps('name'),
	        render:(name) => <span>{name}</span> 	       
	    },
		{
	        title: `Location`,
	        dataIndex: 'address',
	        key: 'address',
	        width: '48%',
	        render:(address) => <span>{displayAddress(address)}</span> 	       
	    },
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/accounts/${accountId}/farms/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'id',
	        key: 'id',
	        width: '12%',
	        render:(id) => <CrudOption baseRoute={`/console/accounts/${accountId}/farms`} recordId={id} deleteHandler={doDelete}/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page, accountId});
    }, [doSearch, pagination.per_page, accountId]);

  	return (
		<div className="h-full overflow-x-scroll xl:overflow-x-hidden mt-4">
			
			<SearchFilter placeholder="Search by Name or ID" searchHandler={doSearch} filters={filters} pagination={pagination}/>
		
			<Table
				dataSource={recordList} 
				columns={columns} 
				rowKey={(record) => record.id}
				pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
				onChange={handleTableChange(doSearch, filters)}  
			/>
		</div>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.farm.recordList?.items,
	pagination: state.farm.recordList?.pagination,
	filters: state.farm.recordList?.filters,
  	requesting: state.farm.recordList?.requesting,
  	error: state.farm.recordList?.error,
  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getFarmList(filters)),
  doDelete: (id) => dispatch(doFarmDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FarmTable);